import { EMediaType, IConstructionProgressImage } from '../../../types/newbuilding/constructionProgress';

export function prepareImages(images: IConstructionProgressImage[]) {
  return images.map(image => ({
    ...image,
    fullUrl: image.url,
    mediumUrl: image.url,
    mediaType: EMediaType.Image,
  }));
}
